// extracted by mini-css-extract-plugin
export default {"wrapper":"Upsell_wrapper__Adkot","isModal":"Upsell_isModal__+DuP6","inner":"Upsell_inner__2ZfcC","title":"Upsell_title__WG6fc","close":"Upsell_close__Adkc3"};